<template>
  <v-container id="details-container">
    <v-layout column>
      <v-flex>
        <div class="headline mt-10">
          If you choose to outsource your accounting, we can balance your books
          and produce detailed monthly management accounting reports to suit
          your needs. We provide the following specific services
        </div>
        <ul class="mt-3">
          <li v-for="(item, index) in list" :key="index">{{ item }}.</li>
        </ul>
      </v-flex>
      <v-flex>
        <div class="headline mt-10 text-center">
          Personal Taxation
        </div>
        <p class="subheading mt-3">
          With taxation laws constantly changing, implications to the taxpayer
          undoubtedly change along with them. Professional guidance is
          essential, whether it be personal or business related.
        </p>
        <p class="subheading">
          Our team will work with you and your family, or your business
          (regardless of size or industry), to tailor solutions based on your
          particular needs and goals.
        </p>
        <p class="subheading">
          Our first priority is to listen, and understand. Only by truly getting
          to know your objectives can we identify the most effective tax
          strategies for you.
        </p>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'HomeDetails',
  data() {
    return {
      list: [
        'Accounting for all sales, purchases and payroll transactions on a monthly and quarterly basis',
        'Payroll accounting',
        'Reconciling accounts such as bank, accounts receivables, accounts payable and various tax collection accounts',
        'Tax tracking of Harmonized Sales Taxes, Goods and Services Taxes and Provincial Sales Taxes',
        'Preparation of HST, GST, PST, WSIB and other government remittances',
        'Monthly management reports and regulatory reports customized to suit your needs'
      ]
    }
  }
}
</script>

<style scoped></style>
